export const FORMAT_DATE = 'yyyy-MM-dd';
